import React, { memo } from 'react';
import { OptionType } from '../../types/optionTypes';

interface OptionDeleteModalProps {
  option: OptionType;
  onConfirm: () => void;
  onCancel: () => void;
}

export const OptionDeleteModal: React.FC<OptionDeleteModalProps> = memo(props => {
  const { option, onConfirm, onCancel } = props;

  return (
    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md">
      <div className="p-6">
        <h3 className="text-xl font-bold text-gray-900 mb-4">Seçenek Türünü Sil</h3>
        <p className="text-gray-600 mb-6">
          <strong>{option.display_name}</strong> seçenek türünü silmek istediğinizden emin misiniz?
          Bu işlem geri alınamaz.
        </p>

        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-6 py-3 text-gray-600 bg-gray-100 rounded-xl hover:bg-gray-200 transition-all"
          >
            İptal
          </button>
          <button
            onClick={onConfirm}
            className="px-6 py-3 bg-red-500 text-white rounded-xl hover:bg-red-600 transition-all"
          >
            Sil
          </button>
        </div>
      </div>
    </div>
  );
});

OptionDeleteModal.displayName = 'OptionDeleteModal';
